export default "__VITE_ASSET__DsyCsTAj__"